module.exports = __webpack_public_path__ + "img/sm4_livinguard_xl.f01cd681.png";